// extracted by mini-css-extract-plugin
module.exports = {"meetWidgetContainer":"widget-demo--meetWidgetContainer--1fog_","noWebRtc":"widget-demo--noWebRtc--2c9So","noWebRtcMessage":"widget-demo--noWebRtcMessage--3NsQE"};